module.exports = __webpack_public_path__ + "static/media/aj.bc9c72d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadBackgroundImg/aj.jpg
// module id = 728
// module chunks = 0